import { render } from "./LoadingNavCompany.vue?vue&type=template&id=baf3a56a"
import script from "./LoadingNavCompany.vue?vue&type=script&lang=js"
export * from "./LoadingNavCompany.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\Erp Con api propia\\ERP CON MI-API\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__